import React from 'react';
import Dialog from '../../common/components/Dialog';
import ui from '../../common/services/ui';

const renderParentInfo = (parent, t) => {
	if (!parent) {
		return;
	}

	return (
		<div>
			{parent.name}<br/>
			{`${t('LessonAttendance_Address')}: ${parent.address}`}<br/>
			{`${t('LessonAttendance_PhoneNumber')}: ${parent.phoneNumber}`}<br/>
			{`${t('LessonAttendance_Email')}: ${parent.email}`}<br/>
			{`${t('LessonAttendance_RegisteredAt')}: ${ui.customDateFormat(parent.registeredAt, 'LLL')}`}<br/><br/>
			{`${t('LessonAttendance_PhotoConsent')}: ${ui.formatBoolean(parent.photoConsent)}`}<br/>
		</div>
	);
}

const configureDialog = (t, parent, onHide) => {
	const info = renderParentInfo(parent, t);
	return {
		header: t('LessonAttendance_Parent'),
		body: info,
		onHide
	};
}

const InfoDialog = ({ t, parent, show, onHide }) => {
	const dialogConfig = configureDialog(t, parent, onHide); 
	return (
		<Dialog config={dialogConfig} show={show} t={t} />
	);
};

export default InfoDialog;